import { useMemo } from "react";

import { useField } from "formik";
import type { Descendant } from "slate";

import { Label } from "components/form/Label/Label";
import { FieldProps } from "types/form";
import { getFieldTestId } from "utils/formik";

import { TextEditor } from "../elements";
import { createMixedValidator } from "./fieldUtils";

export const TextEditorField = (props: FieldProps) => {
  const { name, label, tooltip, required = false, dataTestId } = props;

  const validate = useMemo(
    () => createMixedValidator(name, required),
    [name, required]
  );

  const [field, , helpers] = useField({
    name,
    required,
    validate,
  });
  const testId = dataTestId || getFieldTestId(name);

  const handleChange = (value: Descendant[]) => {
    helpers.setValue(JSON.stringify(value));
  };

  return (
    <div data-test-id={testId}>
      <Label
        text={label}
        tooltip={tooltip}
        required={required}
        dataTestId={`${testId}-label`}
      >
        <TextEditor
          {...props}
          initialValue={field.value || ""}
          dataTestId={`${testId}-input`}
          onChange={handleChange}
        />
      </Label>
    </div>
  );
};
